/**
 * Fieldset validator
 * A utility for keeping track of rendered fields and triggering validation on them
 */

const header = document.querySelector('.header--mobile');
const hiddenClass = 'header__container--hidden';

export type FieldsetField = {
  name: string;
  required?: boolean;
  el?: HTMLElement;
  value?: string;
  valid?: boolean;
  type?: string;
  label?: string;
  hint?: string;
};

export type FieldsetValidator = {
  fields: FieldsetField[];
  register: (field: FieldsetField) => FieldsetField;
  unregister: (fields: string[] | string) => void;
  isValid: (noFocus: boolean) => boolean;
};

export function initFieldsetValidator(): FieldsetValidator {
  let fields: FieldsetField[] = [];

  const register = (field: FieldsetField) => {
    // replace existing field if it exists
    fields = fields.filter((f) => f.name !== field.name);
    fields.push(field);

    return this;
  };

  const unregister = (field: string[] | string) => {
    if (Array.isArray(field)) {
      // from from fields by name
      fields = fields.filter((f) => !field.includes(f.name));
    } else {
      fields = fields.filter((f) => f.name !== field);
    }

    return this;
  };

  const isValid = (noFocus?: boolean) => {
    const invalidFields = [];

    fields.forEach((field) => {
      const { required, valid } = field;

      if (valid === true || required === false) {
        return;
      }

      invalidFields.push(field);

      if (!noFocus && field.el) {
        field.el.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // for mobile enforce header removal to focus on the field
        if (header) {
          setTimeout(() => {
            header.classList.add(hiddenClass);
          }, 500);
        }
      }
    });

    return invalidFields.length === 0;
  };

  return {
    fields,
    register,
    unregister,
    isValid,
  };
}
